
import { Document } from '@/components/documents/types';
import { supabase } from '@/integrations/supabase/client';

export const generatePDF = async (doc: Document) => {
  try {
    console.log('Starting PDF generation for document:', doc.id);
    
    // Call the Supabase Edge Function to generate PDF
    const { data, error } = await supabase.functions.invoke("generate-pdf", {
      body: {
        documentId: doc.id,
      },
    });

    if (error) {
      console.error('PDF generation error:', error);
      throw new Error(`PDF generation failed: ${error.message}`);
    }

    if (!data?.url) {
      console.error('No download URL received:', data);
      throw new Error('No download URL generated');
    }

    console.log('PDF generated successfully, downloading...');

    // Use window.open for download to avoid createElement issues
    const downloadWindow = window.open(data.url, '_blank');
    if (downloadWindow) {
      downloadWindow.focus();
    } else {
      // Fallback: create download link if popup blocked
      const link = document.createElement("a");
      link.href = data.url;
      link.download = `${doc.title.toLowerCase().replace(/\s+/g, "-")}.pdf`;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    return true;
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
};
